import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import {
  BOOKINGS_URL,
  LeftActivePageEnum,
  MAP_URL_PATH,
  RIDES_URL,
  RoutePaths,
  usePrefixedRouting,
} from "@ryde/shared";

export const useLeftbarActivePaths = () => {
  const location = useLocation();
  const { prefix } = usePrefixedRouting();
  const leftActivePage = useMemo((): LeftActivePageEnum => {
    switch (true) {
      case location.pathname.includes(MAP_URL_PATH):
        return LeftActivePageEnum.LiveMap;
      case location.pathname.includes(RIDES_URL):
        return LeftActivePageEnum.Rides;
      case location.pathname.includes(BOOKINGS_URL):
        return LeftActivePageEnum.Bookings;
      case location.pathname.includes(RoutePaths.COURSES):
        return LeftActivePageEnum.Courses;
      case location.pathname.includes(RoutePaths.PASSENGERS):
        return LeftActivePageEnum.Passengers;
      case location.pathname.includes(RoutePaths.REPORTS):
        return LeftActivePageEnum.Reports;
      case location.pathname.includes(RoutePaths.PRODUCE_BUTTONS):
        return LeftActivePageEnum.ProduceButtons;
      case location.pathname.includes(RoutePaths.FEEDBACKS):
        return LeftActivePageEnum.Feedbacks;
      case location.pathname === prefix ||
        location.pathname === RoutePaths.HOME:
        return LeftActivePageEnum.Home;
      default:
        return LeftActivePageEnum.Settings;
    }
  }, [location.pathname, prefix]);

  return { leftActivePage };
};
